module.exports = __webpack_public_path__ + "static/fuego-ae1603fecedfcce6604da5bbefc7ecd2.jpg";